import { useParams } from 'react-router';
import { observer } from 'mobx-react-lite';

import Topic from '@/dmdrive/topic/components/Topic/Topic';

import { ProjectPageRoot } from './ProjectPage.styles';

function ProjectPage() {
  const { conferenceId } = useParams();

  return <ProjectPageRoot>{conferenceId && <Topic topicId={conferenceId} />}</ProjectPageRoot>;
}

export default observer(ProjectPage);
